// utils/enumUtils.js
export const toDropdownOptions = (enumArray) =>
  enumArray.map((value) => ({
    label: value
      .replace(/_/g, " ")       // Replace underscores with spaces
      .toLowerCase()            // Make lowercase
      .replace(/\b\w/g, (c) => c.toUpperCase()), // Capitalize each word
    value,
  }));
